import { GetterTree } from 'vuex';
import { WorkshopsScheduleState } from './types';
import { RootState } from '@/vuex/types';
import { TicketsManager } from '../models/logic/TicketsManager';
import { SheduleBoardWeekDaysAdjuster } from '../models/logic/SheduleBoardWeekDaysAdjuster';
import RestResource from '@/modules/api/RestResource';
import { Registration } from '../models/formModels';

export const getters: GetterTree<WorkshopsScheduleState, RootState> = {
    loading(state) {
        return state.loading;
    },
    isGuidelineVisible(state) {
        return state.isGuidelineVisible;
    },
    isFilteringVisible(state) {
        return state.isFilteringVisible;
    },
    weekSchedule(state) {
        return state.weekSchedule;
    },
    weekDays(state) {
        return state.weekSchedule.WeekDays;
    },
    filteredWeekDays(state, getters, rootState) {
        // const helper = new SheduleBoardWeekDaysAdjuster();
        // const weekDays = helper.getFilteredWeekDays(rootState.calendar?.filteredEvents ?? []);
        // const timeUnits = helper.getTimeUnits(weekDays);
        // weekDays.forEach(weekDay => (weekDay.Timeline = helper.createTimelineFor(weekDay, timeUnits)));

        // helper.setBufferingWorkshops(weekDays, state.timeline);

        // console.log(weekDays);

        // return weekDays;

        return state.filteredWeekDays.sort((a, b) => (a.Id > b.Id ? 1 : a.Id < b.Id ? -1 : 0));
    },
    workshops(state) {
        return new TicketsManager().getVisibleWorkshops(state.weekSchedule.WeekDays);
    },
    timeline(state) {
        return state.timeline;
    },
    selectedWorkshopsIds(state) {
        return state.selectedWorkshopsIds;
    },
    selectedTicketsIds(state) {
        return state.selsctedTicketsIds;
    },
    availableTicketsIds(state) {
        // const availableTicketsIds = [
        //     ...new Set(new TicketsManager().getAvailableTicketsIds(state.weekSchedule.WeekDays)),
        // ].sort((n1, n2) => n1 - n2);
        const availableTicketsIds = [
            ...new Set(state.availableTicketTypes.sort((n1, n2) => n1.Order - n2.Order).map(x => x.Id)),
        ];

        return availableTicketsIds;
    },
    availableTicketsTypes(state) {
        const availableTicketsIds = [...new Set(state.availableTicketTypes)].sort((n1, n2) => n1.Order - n2.Order);

        return availableTicketsIds;
    },
    loadFormStateForRegistration(state, getters, rootState) {
        if (!state.eventRegistrationId || !state.eventRegistrationGuid) {
            return null;
        }
        const EventRegistrationForms =
            rootState.configuration?.environment.apiUrl + `/registrations/EventRegistrationForms`;
        const eventRegistrationFormsResource: RestResource<Registration> = new RestResource<Registration>(
            EventRegistrationForms,
            function() {
                return;
            },
            function() {
                return;
            },
            function(error: any) {
                console.log(error);
            },
        );

        return eventRegistrationFormsResource.getResource(
            `${state.eventRegistrationId}/${state.eventRegistrationGuid}`,
        );
    },
    eventTickets(state) {
        return state.eventTickets;
    },
};
